import { Box, Text } from "@chakra-ui/react";

export const BusinessSecretNote = ({ label, reason }: { label: string; reason: string }) => (
  <Box mt="2" p="3" borderRadius="md" bg="smBackgroundSecondary" fontSize="sm">
    <Text fontWeight="semibold">{label}</Text>
    <Text whiteSpace="pre-wrap" color="smMuted">
      {reason}
    </Text>
  </Box>
);
